export const isLocalhost = () => window.location.hostname === 'localhost';
